import { LOCALE_TYPE } from 'src/types/locale';

export const isLocaleTw = (locale: LOCALE_TYPE) => {
  if (locale === LOCALE_TYPE.TW || locale === LOCALE_TYPE.JA) {
    return true;
  }
  return false;
};

export const isLocaleEn = (locale: LOCALE_TYPE) => locale === LOCALE_TYPE.EN;

export const isLocaleHk = (locale: LOCALE_TYPE) => locale === LOCALE_TYPE.HK;

export const isLocaleCn = (locale: LOCALE_TYPE) => locale === LOCALE_TYPE.CN;

export const isLocaleTwOrHk = (locale: LOCALE_TYPE) => {
  if (locale === LOCALE_TYPE.TW || locale === LOCALE_TYPE.HK) {
    return true;
  }
  return false;
};

export const isLocaleTwOrHkOrCn = (locale: LOCALE_TYPE) => {
  if (locale === LOCALE_TYPE.TW || locale === LOCALE_TYPE.HK || locale === LOCALE_TYPE.CN) {
    return true;
  }
  return false;
};

export const checkLocaleTw = (input: unknown): input is LOCALE_TYPE.TW => {
  return input === LOCALE_TYPE.TW;
};

export const checkLocaleEn = (input: unknown): input is LOCALE_TYPE.EN => {
  return input === LOCALE_TYPE.EN;
};

export const checkLocaleCn = (input: unknown): input is LOCALE_TYPE.CN => {
  return input === LOCALE_TYPE.CN;
};

export const isLocale = (input: string | undefined): input is LOCALE_TYPE =>
  input === LOCALE_TYPE.EN ||
  input === LOCALE_TYPE.JA ||
  input === LOCALE_TYPE.TW ||
  input === LOCALE_TYPE.HK ||
  input === LOCALE_TYPE.CN;
